export default "/institutions/alelo.svg";